import { render, staticRenderFns } from "./FaqsList.vue?vue&type=template&id=bbb7628e&"
import script from "./FaqsList.vue?vue&type=script&lang=js&"
export * from "./FaqsList.vue?vue&type=script&lang=js&"
import style0 from "./FaqsList.vue?vue&type=style&index=0&id=bbb7628e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports